

export const SORTORDER = {
    ASC: "asc",
    DESC: "desc",
} as const

export type SortOrder = typeof SORTORDER[keyof typeof SORTORDER]